import React from 'react'
import QuizCard from './QuizCard'

function Hero() {
  return (
    <section className="hero-section">

        <div className="hero">
            <div className="headings">
                <p className="h1">Test your web dev skills with <span>QuizQuest!</span> </p>
                <p className="h2">Challenge yourself and take your web development skills to the next level with QuizQuest. Our user-friendly and engaging platform offers a range of quizzes designed specifically for developers, providing opportunities for growth and advancement in your career</p>
            </div>
            <div className="quiz-container">
                <p className="h1">Choose one from the below options and click on start Quiz.</p>
                <div className="quizzes">
                    <QuizCard 
                        name={"HTML"}
                        description={"HTML is the foundation of all websites, creating structure and content for web pages"}
                        color={" #D9EEE1"}

                    />
                    <QuizCard 
                        name={"Javascript"}
                        description={"A programming language for web development, scripting, and server-side scripting."}
                        color={"#E0CEEC"}

                    />
                    <QuizCard 
                        name={"ReactJs"}
                        description={"A JS library for building UI, offering reusable components and optimized updates."}
                        color={"#E9CBDA"}

                    />
                    <QuizCard 
                        name={"CSS"}
                        description={"A stylesheet language for describing the look  of a document written in HTML."}
                        color={"#E9CBDA"}

                    />
                    <QuizCard 
                        name={"jQuery"}
                        description={"jQuery makes DOM manipulation, event handling, and animation easier."}
                        color={"#E2ECCE"}

                    />
                    <QuizCard 
                        name={"Git"}
                        description={"A distributed version control system for managing  changes to software projects."}
                        color={"#D9EEE1"}

                    />
                    

                </div>
            </div>
        </div>
    </section>

  )
}

export default Hero